// import * as Sentry from '@sentry/browser';
import Raven from 'raven-js';
import { Integrations } from '@sentry/tracing';

const myCdn = 'https://4022f870647142fb9debdf90751fcf3a@o432040.ingest.sentry.io/5432808';
const release = 'my-project-name@' + process.env.npm_package_version;

// Sentry.init({
//   dsn: myCdn,
//   release: release,
//   integrations: [new Integrations.BrowserTracing()],
//   tracesSampleRate: 1.0, // Be sure to lower this in production
// });

Raven.config(myCdn, {
  release: release,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0, // Be sure to lower this in production
  // whitelistUrls: [
  // /(.+)/,
  // /4022f870647142fb9debdf90751fcf3a@o432040.ingest.sentry.io\/(.+)/,
  // /(.+)abituri\.ge(.+)/,
  // /(.+)localhost:3000(.+)/,
  // /(.+)localhost:8000(.+)/,
  // /localhost/,
  // ],
  includePaths: [
    /https?:\/\/(www\.)?abituri\.ge/,
    /https?:\/\/(www\.)?localhost:3000/,
    /https?:\/\/(www\.)?localhost:8000/,
    /https?:\/\/(www\.)?localhost/,
  ],
  ignoreErrors: ['fb_xd_fragment', /ReferenceError:.*/],
}).install();

// setTimeout(() => {
//   let a = 'asdf';
//   b + a;
// }, 1000);
